import { render } from "./EntityBlockList.vue?vue&type=template&id=60807891&scoped=true&ts=true"
import script from "./EntityBlockList.vue?vue&type=script&lang=ts"
export * from "./EntityBlockList.vue?vue&type=script&lang=ts"

import "./EntityBlockList.vue?vue&type=style&index=0&id=60807891&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60807891"]])

export default __exports__